const legislatie = [
  {
    name: "ROFUIP",
    file: "OME_5726_2024_ROFUIP.pdf",
  },
  {
    name: "ORDIN privind aprobarea Statutului elevului.",
    file: "OM_5707_2024_Statut_elev.pdf",
  },
  {
    name: "Legea învățământului preuniversitar.",
    file: "Legea_invatamantului_preuniversitar_nr_198.pdf",
  },
  {
    name: "ROI",
    file: "ROI 2025-2026.PDF"
  },
  {
    name: "ROF",
    file: "rof 25-26.pdf"
  },
  {
    name: "RAEI",
    file: "RAEI 2024-2025.PDF"
  },
  {
    name: "PAS",
    file: "PAS 2024-2029 actualizat sept.2025.pdf"
  },
  {
    name: "Plan managerial DRF",
    file: "Plan managerial DRF 2025-2026.pdf"
  },
  {
    name: "Scheme orare",
    file: "Scheme orare 2025-2026.PDF"
  },
  {
    name: "Procedura egalizare șanse",
    file: "32051_Procedura egalizare sanse_2025-2026.pdf"
  },
  {
    name: "Calendar examene corigență 2025-2026",
    file: "CALENDAR EXAMENE DE CORIGENȚĂ 2025-2026.pdf"
  },

  {
    name: "Criterii monitorizare evaluare rezultate școlare",
    file: "Criterii_monitorizare_evaluare_rezultate_scolare.pdf"
  },
  {
    name: "Lista posturilor disponibile",
    file: "Lista posturilor disponibile.PDF"
  },
  {
    name: "Program de dezvoltare SCIM",
    file: "Program de dezvoltare SCIM.PDF"
  },
  {
    name: "Raport SCIM",
    file: "Raport SCIM.PDF"
  },
  {
    name: "Starea învățământului",
    file: "Starea invatamantului.pdf"
  },
  {
    name: "Strategia proprie de funcționare CEAC 2024-2029",
    file: "Strategia_proprii_de_functionare_CEAC_2024-2029.pdf"
  }
];

export default function LegislatiePage() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <ul>
          {legislatie.map((legislatie) => (
            <li key={legislatie.file} className="mb-2 flex items-center">
              <span className="font-bold text-xl mr-2">{legislatie.name}</span>
              <a
                href={`/documente/legislatie/${legislatie.file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-4 text-blue-600 underline"
              >
                Deschide
              </a>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}